import React, { useMemo, useRef } from 'react'
import { FleetGrid, useGridList } from '../../../shared/sso-workspace/fleet-grid'
import { IconAnalytic } from '../../../shared/icon/icon'
import { TableAgClient } from '../../../shared/table-builder/table-ag-client'
import { ColumnSelector, ColumnText } from '../../../shared/table-builder/table-columns'
import { OUTCOMES, TRUNCATED_TEXT, connectionText, countText, formatScore, numericComparator } from './launch-format'

const averageText = row => formatScore(row.scoreAverage)

// The launches by LMS connection and course: launches, unique learners,
// completions, the six outcomes, the average score and the analytics sessions
// recorded. A learner is counted once in each row and once in the range, so
// the rows do not add up to the range's unique learners.
export const LaunchSummary = ({ summary }) => {
  const rows = summary.rows
  const tableRef = useRef()
  const gridList = useGridList(rows)
  const emptyState = useMemo(() => ({ Icon: IconAnalytic, title: 'No launches in this range.' }), [])

  return (
    <section className="mt-4" aria-labelledby="lms-summary-title" data-testid="lms-launch-summary-section">
      <h3 className="h6" id="lms-summary-title">Summary by connection and course</h3>
      <p className="small text-body-secondary mb-2">
        Unique learners are counted for each row and for the whole range, so the rows don't add up to the range's total.
      </p>
      <FleetGrid compact tableRef={tableRef} testId="lms-launch-summary">
        <TableAgClient ref={tableRef} apiList={gridList} queryKey="summary" sortCol="connectionName" emptyState={emptyState}>
          <ColumnSelector field="connectionName" header="LMS connection" selector={connectionText} sortable minWidth={170} flex={1} />
          <ColumnText field="courseName" header="Course" sortable minWidth={170} flex={1} />
          <ColumnSelector field="launches" header="Launches" selector={countText('launches')} sortable />
          <ColumnSelector field="uniqueLearners" header="Unique learners" selector={countText('uniqueLearners')} sortable />
          <ColumnSelector field="completions" header="Completions" selector={countText('completions')} sortable />
          {OUTCOMES.map(outcome => <ColumnSelector key={outcome.key} field={outcome.key} header={outcome.label} selector={countText(outcome.key)} sortable />)}
          <ColumnSelector field="scoreAverage" header="Average score" selector={averageText} comparator={numericComparator} sortable />
          <ColumnSelector field="sessionsRecorded" header="Sessions recorded" selector={countText('sessionsRecorded')} sortable />
        </TableAgClient>
      </FleetGrid>
      {summary.truncated && <p className="small text-body-secondary mt-2 mb-0" data-testid="truncated-summary">{TRUNCATED_TEXT}</p>}
    </section>
  )
}
